import { SignatureType } from '@modusign/react-signing/types';
import isEqual from 'lodash/isEqual';

import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';

export const MIN_STAMP_SIZE = createAbsoluteSize({ width: 50, height: 50 });
export const MIN_SIGN_SIZE = createAbsoluteSize({ width: 70, height: 26.92 });

export const MAX_STAMP_SIZE = createAbsoluteSize({ width: 180, height: 180 });
export const MAX_SIGN_SIZE = createAbsoluteSize({ width: 260, height: 100 });

export function getMinSignatureFieldSize(allow: SignatureType[], scale: number) {
  if (isEqual(allow, ['SIGN', 'STAMP']) || isEqual(allow, ['STAMP'])) {
    return createAbsoluteSize({
      width: MIN_STAMP_SIZE.width * scale,
      height: MIN_STAMP_SIZE.height * scale,
    });
  }
  return createAbsoluteSize({
    width: MIN_SIGN_SIZE.width * scale,
    height: MIN_SIGN_SIZE.height * scale,
  });
}

export function getMaxSignatureFieldSize(allow: SignatureType[], scale: number) {
  if (isEqual(allow, ['SIGN', 'STAMP']) || isEqual(allow, ['STAMP'])) {
    return createAbsoluteSize({
      width: MAX_STAMP_SIZE.width * scale,
      height: MAX_STAMP_SIZE.height * scale,
    });
  }
  return createAbsoluteSize({
    width: MAX_SIGN_SIZE.width * scale,
    height: MAX_SIGN_SIZE.height * scale,
  });
}

export function calculateSignatureResizeAdjustedSize(allow: SignatureType[], size: AbsoluteSize) {
  if (isEqual(allow, ['STAMP'])) {
    return createAbsoluteSize({
      width: size.width,
      height: size.width,
    });
  }
  if (isEqual(allow, ['SIGN'])) {
    return createAbsoluteSize({
      width: size.width,
      height: size.width * (MIN_SIGN_SIZE.height / MIN_SIGN_SIZE.width),
    });
  }
  return size;
}
